import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { CardActions } from 'src/app/user/user.model';

@Component({
    selector: 'app-step-info-not-connected',
    templateUrl: './info-not-connected.component.html',
    styleUrls: ['./info-not-connected.component.scss'],
})
export class StepInfoNotConnectedComponent implements OnInit, OnDestroy {
    destroy$ = new Subject();

    @Input() form: FormGroup;
    @Input() instructionsStepsInfo: string;
    @Input() subTypes;
    @Input() cardActions: CardActions;

    CardActions = CardActions;

    hideExpDate = false;

    tomorrow = new Date();

    constructor(private translateService: TranslateService) {}

    get firstName() {
        return this.form.get('firstName').value;
    }
    get lastName() {
        return this.form.get('lastName').value;
    }
    get sex() {
        return this.form.get('sex').value;
    }
    get picture() {
        return this.form.get('picture').value;
    }
    get birthDate() {
        return this.formatDate(this.form.get('birthDate').value);
    }
    get address() {
        return this.form.get('address').value;
    }
    get subType() {
        return this.form.get('subType').value;
    }
    get cardNumber() {
        return this.form.get('cardNumber').value;
    }
    get expDate() {
        return this.form.get('expDate').value;
    }

    ngOnInit(): void {
        this.tomorrow.setDate(this.tomorrow.getDate() + 1);
    }

    formatDate(date: string) {
        if (!date) {
            return '';
        }
        // Extract date portion from ISO string to avoid timezone conversion issues
        let dateString = date;
        if (date.includes('T')) {
            dateString = date.split('T')[0];
        }
        // Parse date components and create Date in local timezone
        const [year, month, day] = dateString.split('-').map(Number);
        const tempDate = new Date(year, month - 1, day);
        const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric' };
        return new Intl.DateTimeFormat(`${this.translateService.currentLang}-CA`, options).format(tempDate);
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
